import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ApproveDraftIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ApproveDraft",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M11.43 18.38c-.35-.46-1.05-.46-1.51-.12-.46.35-.46 1.05-.12 1.51l.12.12 3.83 3.83c.46.35 1.16.35 1.51 0l7.09-7.09c.35-.46.35-1.16-.12-1.51s-1.05-.35-1.39 0l-6.39 6.39-3.02-3.14Zm15.68-8.13c-.12-.12-.12-.23-.23-.35l-7.55-7.55c-.12-.12-.23-.12-.23-.23h-.12c-.12 0-.23-.12-.35-.12H9.1C6.78 2 4.92 3.86 4.8 6.18v20.1C4.8 28.49 6.54 30 8.98 30h13.94c2.44 0 4.18-1.51 4.18-3.72V10.94c.12-.23.12-.58 0-.7ZM24.44 26.4c0 .81-.81.93-1.39.93H9.11c-.7 0-1.39-.12-1.39-.93V6.3c0-.81.58-1.39 1.39-1.39h7.9v5.11c0 1.28 1.05 2.32 2.32 2.32h5.11z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M25.86 29.29H5.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14h20.57c.63 0 1.14-.51 1.14-1.14v-9.14a1.14 1.14 0 1 1 2.28 0v9.14c0 1.89-1.54 3.43-3.43 3.43Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 13.29h-6.86c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86a1.14 1.14 0 1 1 0 2.28ZM14.67 23.28c-.3 0-.59-.12-.81-.33l-3.16-3.16c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l2.32 2.32 4.17-4.54c.43-.46 1.15-.5 1.61-.07.47.43.5 1.15.07 1.62l-4.97 5.42c-.21.23-.51.36-.82.37h-.02Z"
      })]
    })
  }));
};
ApproveDraftIcon.displayName = 'ApproveDraftIcon';